module.exports = __webpack_public_path__ + "static/media/incorrectInformation.bb71a8f3.svg";